<template>
  <div class="account_close_notice">
    <section class="notice_panel">
      <p class="intro">
        请您注意，账号注销属于永久不可恢复的操作。在您确认注销账号之前，请仔细阅读并充分理解《账号注销须知》（以下简称"本须知"），尤其应重点关注以粗体标识的条款内容。一旦您点击“同意”（具体表述以相关页面最终显示为准），即表示您已完整阅读、知悉并同意接受本须知的全部内容。
      </p>

      <article v-for="section in sections" :key="section.title" class="section">
        <h2 class="section_title">{{ section.title }}</h2>
        <p
          v-for="text in section.contents"
          :key="text"
          v-html="formatContent(text)"
        />
      </article>
    </section>
  </div>
</template>

<script>
import { setPageTitle } from "@/bridge/AppJsBridge";

export default {
  name: "AccountCloseNotice",
  data() {
    return {
      sections: [
        {
          title: "一、注销需满足的条件",
          contents: [
            "在您申请注销账号前，为保障您的账号与财产安全，需确保您所要注销的账号同时满足以下全部条件，包括但不限于：",
            "1.1 该账号须为您本人通过我们官方渠道注册，且符合我们平台的相关协议与规范要求。",
            "1.2 该账号处于安全、正常的使用状态，不存在盗号、封禁、限制登录、异常登录等安全风险。",
            "1.3 该账号已解除所有特殊身份关系及相关权限（如机构认证、开发者认证等）。",
            "1.4 该账号已解除与第三方产品及服务之间的授权或绑定关系。",
            "1.5 该账号内所有服务、订单及交易均已处理完毕或关闭。",
            "1.6 该账号内资产及权益已全部结清、消耗、处理或由您自愿放弃。",
            "1.7 该账号不存在任何未解决的纠纷、争议、投诉或申诉，亦不存在因注销而尚未了结的权利义务关系。",
          ],
        },
        {
          title: "二、注销账号的影响",
          contents: [
            "您确认注销账号即表示您已充分了解并自愿接受由此产生的一切后果，包括但不限于以下内容：",
            "2.1 账号注销后，您将无法继续使用该账号登录或使用平台及相关服务，包括但不限于进行任何交易或享受售后支持；同时，您也无法通过该账号使用或登录任何已授权登录、绑定或已关联的第三方产品及服务。账号一经注销即为不可恢复的操作，即使您使用同一手机号重新注册，也无法恢复原账号内的任何内容、数据、资产或权益。",
            "2.2 账号注销后，您使用该账号期间产生的全部信息与数据将会被删除或进行匿名处理（法律法规另有规定的除外），前述信息与数据包括但不限于：（1）账号内个人资料（如头像、昵称、实名信息、身份信息、支付信息、联系方式等）；（2）账号相关数据及记录（如关注、收藏、点赞、评论、帖子、动态、私信、好友关系、预约记录、浏览记录、等级成就、游戏数据、交易记录等）；（3）通过该账号授权登录或绑定的第三方产品及服务的信息和数据等。请您在注销前自行备份所需信息，注销后相关数据将无法找回或恢复。",
            "2.3 您理解并同意，一旦您确认注销，即视为您自愿且不可撤销地放弃该账号及通过该账号授权登录、绑定或关联的第三方产品及服务内的全部资产、权益及其他财产性利益，包括但不限于：（1）充值余额、红包、礼品卡、优惠券、代金券、卡券、道具、皮肤、点数、积分、等级等；（2）各类资格、会员权益、身份权益、服务权益；（3）您已获取或购买的产品及服务（云挂机服务、会员服务等）；（4）您发布的内容/产品未来的收益及相关权益；（5）该账号下其他已产生但尚未消耗的权益或未来可能产生的预期利益。特别提醒：注销成功后，您将无法使用、处分或主张上述任何资产及权益，我们亦无法为您恢复、找回或进行补偿，由此引发的一切后果将由您自行承担。",
          ],
        },
        {
          title: "三、我们的权利",
          contents: [
            "3.1 您应确保您有权注销该账号，且该操作不侵犯任何第三方的合法权益。如因注销行为引发任何争议、纠纷或投诉，相应责任由您自行承担。如您的账号存在权属争议，我们有权冻结该账号，直至争议各方通过和解或司法途径解决并向我们提供有效证明。在此期间，我们有权拒绝该账号的注销操作。",
            "3.2 如在您申请注销账号时，您的账号涉及争议、纠纷、被举报或投诉、被国家机关调查、正处于诉讼或仲裁程序中，或存在其他需要核实账号相关事项的合理情形的，我们有权自行决定冻结账号或终止注销流程，且无需另行获得您的同意。",
            "3.3 为保障您的合法权益，我们有权根据您的账号安全状态、您的相关产品与服务的使用情况等综合判断您的账号是否符合注销条件，同时我们有权进行注销申请的身份验证以判断您是该账号的有权使用人（如手机验证方式）。在处理账号注销申请时，我们可能需要您提供个人信息（如姓名、身份证号码、账号注册信息、账号登录信息等），用于账号的身份验证，完成账号注销后，该信息我们将进行删除或将根据《用户协议》与《隐私政策》中的约定进行处理。",
            "3.4 如我们在综合判断后发现该游戏账号不符合注销条件的，或者身份验证失败的，您的注销可能会失败，您可以按照我们的指引执行后续操作或者联系客服协助处理。即使我们判断您符合注销条件，也是基于您的承诺（即您自身确保该账号符合上述注销条件的承诺及同意注销后果）进行的形式审查，仍由您自身对该账号申请注销的行为承担责任，我们对此不承担相应的法律责任。",
          ],
        },
        {
          title: "四、其他",
          contents: [
            "4.1 账号注销后，您与我们基于该账号签订的相关协议及对应权利义务即告终止，但法律法规或相关协议另有约定的除外。账号注销并不免除或减轻您在注销前因使用该账号所产生的责任，我们仍有权依据平台协议及规则等追究相应责任。",
            "4.2 我们在收到您的账号注销申请后，我们将立即注销您的账号或在法律法规规定的期限及15个工作日内答复及处理您的请求。",
            "4.3 本须知未尽事宜，可参照您在注册账号时我们之间的《用户服务协议》《隐私政策》及我们已发布或将来可能发布/更新的各类规则。如本须知与前述规则存在不一致，应以本须知的规定为准。",
            "4.4 本协议签订地为中华人民共和国杭州市余杭区，若您与我们之间因注销账号发生任何纠纷或争议，首先应友好协商；协商不成的，您同意将纠纷或者争议提交杭州仲裁委员会申请仲裁。",
            "4.5 我们保留对本须知修改、删除、更新的权利。",
            "4.6 如在注销过程中有疑惑，请您及时与我们平台客服或者通过以下所列联系方式（box@wanxinbuzhi.com）联系我们，我们将在15个工作日内或法律法规规定的期限内答复您的请求。",
          ],
        },
      ],
      // 需加粗展示的条款文案（按长度降序匹配，避免短句误匹配）
      highlightPhrases: [
        "您自愿且不可撤销地放弃该账号及通过该账号授权登录、绑定或关联的第三方产品及服务内的全部资产、权益及其他财产性利益，包括但不限于：（1）充值余额、红包、礼品卡、优惠券、代金券、卡券、道具、皮肤、点数、积分、等级等；（2）各类资格、会员权益、身份权益、服务权益；（3）您已获取或购买的产品及服务（云挂机服务、会员服务等）；（4）您发布的内容/产品未来的收益及相关权益；（5）该账号下其他已产生但尚未消耗的权益或未来可能产生的预期利益。特别提醒：注销成功后，您将无法使用、处分或主张上述任何资产及权益，我们亦无法为您恢复、找回或进行补偿，由此引发的一切后果将由您自行承担",
        "您使用该账号期间产生的全部信息与数据将会被删除或进行匿名处理（法律法规另有规定的除外），前述信息与数据包括但不限于：（1）账号内个人资料（如头像、昵称、实名信息、身份信息、支付信息、联系方式等）；（2）账号相关数据及记录（如关注、收藏、点赞、评论、帖子、动态、私信、好友关系、预约记录、浏览记录、等级成就、游戏数据、交易记录等）；（3）通过该账号授权登录或绑定的第三方产品及服务的信息和数据等。请您在注销前自行备份所需信息，注销后相关数据将无法找回或恢复",
        "您将无法继续使用该账号登录或使用平台及相关服务，包括但不限于进行任何交易或享受售后支持；同时，您也无法通过该账号使用或登录任何已授权登录、绑定或已关联的第三方产品及服务。账号一经注销即为不可恢复的操作，即使您使用同一手机号重新注册，也无法恢复原账号内的任何内容、数据、资产或权益",
        "即使我们判断您符合注销条件，也是基于您的承诺（即您自身确保该账号符合上述注销条件的承诺及同意注销后果）进行的形式审查，仍由您自身对该账号申请注销的行为承担责任，我们对此不承担相应的法律责任",
        "本协议签订地为中华人民共和国杭州市余杭区，若您与我们之间因注销账号发生任何纠纷或争议，首先应友好协商；协商不成的，您同意将纠纷或者争议提交杭州仲裁委员会申请仲裁",
        "您确认注销账号即表示您已充分了解并自愿接受由此产生的一切后果",
        "需确保您所要注销的账号同时满足以下全部条件",
        "该账号内资产及权益已全部结清、消耗、处理或由您自愿放弃",
        "账号注销并不免除或减轻您在注销前因使用该账号所产生的责任，我们仍有权依据平台协议及规则等追究相应责任",
      ],
    };
  },
  created() {
    setPageTitle("账号注销须知");
  },
  mounted() {
    this.$nextTick(() => {
      this.resetScroll();
    });
  },
  methods: {
    resetScroll() {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    formatContent(text) {
      let html = text;
      this.highlightPhrases.forEach((phrase) => {
        if (html.includes(phrase)) {
          html = html.replace(phrase, `<strong>${phrase}</strong>`);
        }
      });
      return html;
    },
  },
};
</script>

<style lang="scss" scoped>
.account_close_notice {
  min-height: 100vh;
  padding: 12px;
  background: #f7f8fa;
  color: #333;
}

.notice_panel {
  padding: 18px 16px 24px;
  background: #fff;
  border-radius: 12px;
}

.intro,
.section p {
  color: #555;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
}

.section {
  margin-top: 22px;

  .section_title {
    margin-bottom: 8px;
    color: #111;
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
  }

  p + p {
    margin-top: 6px;
  }

  :deep(strong) {
    color: #111;
    font-weight: 700;
  }
}
</style>
